import { indexBy, prop } from 'ramda';

import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const fetchAppointments = (_, { payload }) => indexBy(prop('rel'))(payload.links);

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENTS_SUCCESS]: fetchAppointments,
});
